import { Injectable , Output, EventEmitter} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
	@Output() reloadData: EventEmitter<boolean> = new EventEmitter();

	_updateTable(){
		this.reloadData.emit(true);
	}
}
